import { render } from "./MiniProgram.vue?vue&type=template&id=baefbc66&scoped=true"
import script from "./MiniProgram.vue?vue&type=script&lang=js"
export * from "./MiniProgram.vue?vue&type=script&lang=js"

import "./MiniProgram.vue?vue&type=style&index=0&id=baefbc66&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baefbc66"]])

export default __exports__